// Library imports
import styled from 'styled-components';
import store, { RootState } from 'store';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { FC, useEffect, useState } from 'react';
// Local imports
import { ITab } from '../interfaces';
import useQuery from '../../../hooks/useQuery';
import { resetRedirectUrls } from '../actions';
import AnalyticsTabOption from '../Shared/AnalyticsTabOption';
import { resetContentContactsList } from '../Contacts/action';
import StickyHeader from '../../Common/Components/StickyHeader';
import TabsWrapper from 'modules/Common/Components/TabsWrapper';
import StickyHeaderAnalytics from '../../Common/Components/StickyHeaderAnalytics';
import { PATH_ANALYTICS, TAB_ANALYTICS, TAB_ANALYTICS_INNER } from 'constants/paths';
import { getQueryAccountId, getQueryContactId, getQueryPageSource, getQueryParam, removeAccountContactIdFromQueryParams } from 'utils';
import { CONTACT_ANALYTICS, ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS, CONTACTS_INNER_ANALYTICS } from 'constants/types';
import {
  getAnalyticsFilterId,
  getQueryAllCampaigns,
  getQueryArticleId,
  getQueryArticleLink,
  getQueryCampaignId,
  getQueryEmailId,
  getQueryFormId,
  getQueryWorkflowId,
} from 'modules/EmailBrowser/utils';
import { resetAccountsEmailEngagement, resetAccountsEmailEngagementDate, resetContactEmailEngagementDate, resetContactsEmailEngagement, setAccountsEmailEngagementEmailsByFilter, setContactEmailEngagementEmailsByFilter } from '../Contacts/ContactsInner/EmailEngagement/actions';

export type IAnalyticsHeaderSticky = {
  page: string;
  tab: string;
};

const AnalyticsHeaderSticky: FC<IAnalyticsHeaderSticky> = (props) => {
  // Props
  const { page, tab } = props;
  // Local States
  const [showBack, setShowBack] = useState(false);
  // Redux States
  const salesXUsagePermission = useSelector((state: RootState) => state.user.salesXUsage);
  const xiq_internal_user = useSelector((state: RootState) => state.user.xiq_internal_user);
  const { articleTitle, articleUrl } = useSelector((state: RootState) => state.analyticsContent);
  const selectedPerson = useSelector((state: RootState) => state.contactAnalytics.selectedPerson);
  const redirectUrlContacts = useSelector((state: RootState) => state.contactAnalytics.redirectUrl);
  const selectedAccount = useSelector((state: RootState) => state.analyticsAccounts.selectedAccount);
  const redirectUrlAccounts = useSelector((state: RootState) => {
    return state.accountsContentEngagement.redirectUrl === '' ? state.accountsContentEngagement.redirectUrl : state.accountsDashboard.redirectUrl;
  });
  // Local variables
  let query = useQuery();
  const history = useHistory();
  const emailId = getQueryEmailId();
  const fsId = getAnalyticsFilterId();
  const articleId = getQueryArticleId();
  const workflowId = getQueryWorkflowId();
  const campaignId = getQueryCampaignId();
  const articleLink = getQueryArticleLink();
  const analyticsRedirectUrl = localStorage.getItem('analytics_back_url');
  const queryAllCampaign = getQueryAllCampaigns() === 'false' ? false : true;
  const showBackButton = query.get('show_back') === 'true' ? true : false;
  const paramsWithOutAccountContactId = removeAccountContactIdFromQueryParams();
  let contactsDashboardUrl =
    window.location.search.length > 0
      ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_ANALYTICS_INNER.DASHBOARD}/${window.location.search}`
      : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_ANALYTICS_INNER.DASHBOARD}`;
  let contactsDashboardEmailEngagement =
    window.location.search.length > 0
      ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_ANALYTICS_INNER.EMAIL_ENGAGEMENT}/${window.location.search}`
      : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_ANALYTICS_INNER.DASHBOARD}/${TAB_ANALYTICS_INNER.EMAIL_ENGAGEMENT}`;
  let contactsContentUrl =
    window.location.search.length > 0
      ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_ANALYTICS_INNER.CONTENT}/${window.location.search}`
      : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_ANALYTICS_INNER.CONTENT}/`;
  let accountsDashboardUrl =
    window.location.search.length > 0
      ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}/${TAB_ANALYTICS_INNER.DASHBOARD}/${window.location.search}`
      : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}/${TAB_ANALYTICS_INNER.DASHBOARD}`;
  let accountsDashboardEmailEngagement =
    window.location.search.length > 0
      ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}/${TAB_ANALYTICS_INNER.EMAIL_ENGAGEMENT}/${window.location.search}`
      : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}/${TAB_ANALYTICS_INNER.DASHBOARD}/${TAB_ANALYTICS_INNER.EMAIL_ENGAGEMENT}`;
  let accountsContentUrl =
    window.location.search.length > 0
      ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}/${TAB_ANALYTICS_INNER.CONTENT}/${window.location.search}`
      : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}/${TAB_ANALYTICS_INNER.CONTENT}`;

  const getSubTabsTitle = () => {
    let label = '';
    let subTitle = '';
    if (
      tab === TAB_ANALYTICS_INNER.DASHBOARD ||
      tab === TAB_ANALYTICS_INNER.CONTENT ||
      tab === TAB_ANALYTICS.CONTACTS ||
      tab === TAB_ANALYTICS_INNER.EMAIL_ENGAGEMENT
    ) {
      if (page === 'accounts') {
        subTitle = selectedAccount ? selectedAccount : '';
        label = 'Account Analytics';
      } else if (page === 'contacts') {
        subTitle = selectedPerson ? (selectedPerson?.contact_name?.trim() !== '' ? selectedPerson?.contact_name : selectedPerson?.contact_email) : '';
        label = 'Person Analytics';
      } else if (page === 'content') {
        subTitle = articleTitle ? articleTitle : articleUrl;
        label = 'Content Analytics';
      }
    }

    return { label: label, subTitle: subTitle };
  };
  const tabsArray: Array<ITab> = [
    {
      id: 1,
      pillName: 'Dashboard',
      to:
        window.location.search.length > 0
          ? window.location.search.includes('account_id') || window.location.search.includes('contact_id')
            ? `/${PATH_ANALYTICS}/${paramsWithOutAccountContactId}`
            : `/${PATH_ANALYTICS}/${window.location.search}`
          : `/${PATH_ANALYTICS}/`,
      isActive: page === undefined || page === '/',
      onClick: (e: any) => {
        store.dispatch({ type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET });
      },
    },
    {
      id: 2,
      pillName: 'Accounts',
      to:
        window.location.search.length > 0
          ? window.location.search.includes('account_id') || window.location.search.includes('contact_id')
            ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}${paramsWithOutAccountContactId}`
            : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}${window.location.search}`
          : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.ACCOUNTS}`,
      isActive: page === TAB_ANALYTICS.ACCOUNTS,
      onClick: (e: any) => store.dispatch({ type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET }),
    },
    {
      id: 3,
      pillName: 'Contacts',
      isActive: page === TAB_ANALYTICS.CONTACTS,
      to:
        window.location.search.length > 0
          ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/delivered${window.location.search}`
          : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/delivered`,
      onClick: (e: any) => store.dispatch({ type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET }),
    },
    {
      id: 4,
      pillName: 'Content',
      isActive: page === TAB_ANALYTICS.CONTENT,
      to:
        window.location.search.length > 0
          ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTENT}/${window.location.search}`
          : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTENT}/`,
      onClick: (e: any) => store.dispatch({ type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET }),
    },
  ];

  const subTabsArray: Array<ITab> = [
    {
      id: 8,
      pillName: 'Dashboard',
      to: page === 'contacts' ? contactsDashboardUrl : page === 'accounts' ? accountsDashboardUrl : null,
      isActive: tab === 'dashboard',
    },
    {
      id: 9,
      pillName: 'Email Engagement',
      to: page === 'contacts' ? contactsDashboardEmailEngagement : page === 'accounts' ? accountsDashboardEmailEngagement : null,
      isActive: tab === 'email_engagement',
    },
    {
      id: 10,
      pillName: 'Content Engagement',
      to: page === 'contacts' ? contactsContentUrl : page === 'accounts' ? accountsContentUrl : null,
      isActive: tab === 'content',
    },
  ];

  const redirectToListingPage = () => {
    const formId = getQueryFormId();
    const rowId = query.get('row_id');
    const contactId = getQueryContactId();
    const accountId = getQueryAccountId();
    const articleId = getQueryArticleId();
    const pageSource = getQueryPageSource();
    const articleLink = getQueryArticleLink();
    const goBackUrl = getQueryParam('back_url');
    const emailEngagement = window.location.pathname.includes('email_engagement');
    const rowIdContent = query.get('row_id_content');
    const analyticsPage = history.location.pathname.split('/')[1];
    if (pageSource === 'analytics-content') {
      let queryParams = new URLSearchParams(window.location.search);

      if (queryParams.get('contact_id')) {
        queryParams.delete('contact_id');
      }
      if (queryParams.get('page_source')) {
        queryParams.delete('page_source');
      }
      queryParams.delete('row_id');
      queryParams.append('fromId_analytics', rowId!);
      if (formId) {
        history.push(`/settings/forms/?form_id=${formId}`);
      } else {
        history.push(`/analytics/content/${queryParams.toString().trim() !== '' ? '?' + queryParams.toString().trim() : ''}`);
      }
      store.dispatch({
        type: CONTACTS_INNER_ANALYTICS.DASHBOARD_RESET,
      });
      store.dispatch({
        type: CONTACTS_INNER_ANALYTICS.CONTENT_RESET,
      });
      store.dispatch({
        type: CONTACT_ANALYTICS.SELECTED_PERSON_RESET,
      });
      return;
    }
    if (tab === TAB_ANALYTICS_INNER.DASHBOARD || tab === TAB_ANALYTICS_INNER.CONTENT || tab === TAB_ANALYTICS.CONTACTS || tab === TAB_ANALYTICS.EMAIL_ENGAGEMENT) {
      if (page === 'accounts') {
        store.dispatch({ type: CONTACT_ANALYTICS.RESET_ALL });
        resetAccountsEmailEngagement();
        setAccountsEmailEngagementEmailsByFilter('');
        resetAccountsEmailEngagementDate();
        resetRedirectUrls();
        if ((campaignId || queryAllCampaign) && showBackButton) {
          localStorage.removeItem('analytics_back_url');
          analyticsRedirectUrl && history.push(analyticsRedirectUrl);
        } else {
          history.push(redirectUrlAccounts !== '' ? redirectUrlAccounts : fsId ? `/analytics?fs_id=${fsId}` : '/analytics');
          return;
        }
      } else if (page === 'contacts' && !(articleId || articleLink)) {
        store.dispatch({ type: CONTACT_ANALYTICS.FILTER_RESET, payload: true });
        resetContactsEmailEngagement();
        setContactEmailEngagementEmailsByFilter('');
        resetContactEmailEngagementDate();
        resetRedirectUrls();
        if ((campaignId || queryAllCampaign) && showBackButton) {
          store.dispatch({
            type: CONTACTS_INNER_ANALYTICS.DASHBOARD_RESET,
          });
          store.dispatch({
            type: CONTACTS_INNER_ANALYTICS.CONTENT_RESET,
          });
          store.dispatch({
            type: CONTACT_ANALYTICS.SELECTED_PERSON_RESET,
          });
          localStorage.removeItem('analytics_back_url');
          analyticsRedirectUrl && history.push(analyticsRedirectUrl);
        } else {
          if (goBackUrl && !fsId) {
            history.push(decodeURIComponent(goBackUrl));
          } else {
            history.push(redirectUrlContacts !== '' ? redirectUrlContacts : fsId ? `/analytics?fs_id=${fsId}` : '/analytics');
          }
          return;
        }
      } else if (page === 'contacts' && (articleId || articleLink)) {
        let artilceParams = articleId ? `article_id=${articleId}` : articleLink ? `article_link=${articleLink}` : '';
        if (rowId) {
          artilceParams ? (artilceParams = artilceParams + `&fromId_analytics=${rowId}`) : (artilceParams = `?fromId_analytics=${rowId}`);
        }
        if (rowIdContent) {
          artilceParams ? (artilceParams = artilceParams + `&row_id_content=${rowIdContent}`) : (artilceParams = `?row_id_content=${rowIdContent}`);
        }
        resetRedirectUrls();
        history.push(
          fsId
            ? `/analytics/content/contacts/?fs_id=${fsId}&${artilceParams ? artilceParams : ''}`
            : `/analytics/content/contacts/?${artilceParams ? artilceParams : ''}`,
        );
        return;
      } else if (page === 'content') {
        let queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('article_id')) {
          queryParams.delete('article_id');
        }
        if (queryParams.get('article_link')) {
          queryParams.delete('article_link');
        }
        queryParams.delete('row_id_content');
        queryParams.append('fromId_content', rowIdContent!);
        resetContentContactsList();
        resetRedirectUrls();
        history.push(`/analytics/content/${queryParams.toString().trim() !== '' ? '?' + queryParams.toString().trim() : ''}`);
        return;
      }
    } else if (analyticsPage === 'analytics' && history.location.pathname.split('/').length) {
      if (page === 'contacts' && window.location.search.includes('account_id')) {
        history.push(`/analytics/accounts/dashboard/${window.location.search}`);
        return;
      }
      if (analyticsRedirectUrl) {
        localStorage.removeItem('analytics_back_url');
        history.push(analyticsRedirectUrl);
      }
      if (workflowId) {
        let redirect = query.get('redirect');
        if (redirect === 'automation') {
          history.push(`/automation?fromId=${workflowId}`);
        } else {
          history.push(`/automation/details?workflow_id=${workflowId}`);
        }
      }
    }
    return undefined;
  };

  useEffect(() => {
    if (window.location.search.includes('account_id') || window.location.search.includes('contact_id')) {
      if (!queryAllCampaign && showBackButton) setShowBack(true);
      else setShowBack(false);
    }
  }, []);

  useEffect(() => {
    if (tab === TAB_ANALYTICS_INNER.CONTENT || tab === TAB_ANALYTICS_INNER.DASHBOARD || tab === TAB_ANALYTICS.CONTACTS || tab === TAB_ANALYTICS_INNER.EMAIL_ENGAGEMENT) {
      if (page === 'accounts' || page === 'contacts' || page === 'content') {
        if (!queryAllCampaign && showBackButton) setShowBack(true); // this check will check whether show_back is false or true
        else {
          if (!window.location.search.includes('show_back') && !queryAllCampaign) setShowBack(true); // this check we check do we have this parameter or not
          else {
            if (window.location.search.includes('account_id') && window.location.search.includes('contact_id')) setShowBack(true);
            else setShowBack(false);
          }
        }
        if (queryAllCampaign && showBackButton) setShowBack(true);
      }
    } else if (page === 'contacts' && window.location.search.includes('account_id')) {
      if (!queryAllCampaign) setShowBack(true);
    } else {
      setShowBack(false);
    }
    if (
      (window.location.search.includes('campaign_id') || window.location.search.includes('email_id')) &&
      showBackButton
    ) {
      setShowBack(true);
    }
    if (window.location.search.includes('workflow_id') && !showBackButton) {
      setShowBack(true);
    }
  }, [tab, page]);

  useEffect(() => {
    // to remove the back button if user click on analytics from left sidebar
    if (!campaignId && !emailId && !workflowId && !(articleId || articleLink) && !(page === 'contacts' || page === 'accounts')) {
      setShowBack(false);
    }
  }, [campaignId, emailId, workflowId]);

  // title of the page selected using :page param
  const title = 'Analytics';
  const salesXTabText = (
    <>
      Sales Xelerator<sup>TM</sup> Usage
    </>
  );
  const { label, subTitle } = getSubTabsTitle();
  if (xiq_internal_user) {
    tabsArray.push({
      id: 5,
      pillName: 'Trends',
      isActive: page === TAB_ANALYTICS.TRENDS,
      to: `/${PATH_ANALYTICS}/${TAB_ANALYTICS.TRENDS}/${window.location.search}`,
      onClick: () => { },
    });
    tabsArray.push({
      id: 6,
      pillName: 'Insights',
      isActive: page === TAB_ANALYTICS.INSIGHTS,
      to: `/${PATH_ANALYTICS}/${TAB_ANALYTICS.INSIGHTS}/${window.location.search}`,
      onClick: () => { },
    });
  }
  if (salesXUsagePermission) {
    tabsArray.push({
      id: 7,
      pillName: salesXTabText,
      isActive: false,
      to: `https://workbench.xiqonline.com/dashboards/app_usage_main/`,
      onClick: () => { },
    });
  }
  return (
    <>
      <Wrapper>
        <StickyHeader>
          <StickyHeaderAnalytics
            label={tab === 'dashboard' || tab === 'content' || tab === 'contacts' || tab === TAB_ANALYTICS_INNER.EMAIL_ENGAGEMENT ? label : ''}
            title={tab === 'dashboard' || tab === 'content' || tab === 'contacts' || tab === TAB_ANALYTICS_INNER.EMAIL_ENGAGEMENT ? subTitle : title}
            showBack={showBack}
            externalRedirect={redirectToListingPage}
          >
            {tab === 'contacts' ? null : (
              <TabsWrapper>
                <AnalyticsTabOption
                  tabArray={tab === 'dashboard' || tab === 'content' || tab === TAB_ANALYTICS_INNER.EMAIL_ENGAGEMENT ? subTabsArray : tabsArray}
                />
              </TabsWrapper>
            )}
          </StickyHeaderAnalytics>
        </StickyHeader>
      </Wrapper>
    </>
  );
};

export default AnalyticsHeaderSticky;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 57px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding-top: 47px;
  }
`;
